export enum ImageSource {
  IndividualApi = 'individual'
}



// WEBPACK FOOTER //
// ./src/components/App/imageQueue/enum/imageSource.ts